import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Loader from "../component/Loader";
import NavBar from "../component/NavBar";
import { ADMIN_ROUTES } from "../utils/routesUtils";
import "./AdminSection.css";
import { Toaster } from "react-hot-toast";
import { AdminContext } from "../context/context";
const AdminSection = () => {
  const [route, setRoute] = useState();
  const [loader, setLoader] = useState(true);
  const [state, setState] = useState(true);
  const navigate = useNavigate();
  const path = window.location.pathname;
  // localStorage.setItem("adminAuthToken", "dummyToken");
  const authToken = localStorage.getItem("adminAuthToken");

  useEffect(() => {
    setLoader((prev) => true);
    if (process.env.REACT_APP_ENV === "uat") {
      const routeObj = ADMIN_ROUTES.find(
        (item, i) => `/chatgptui${item.path}` === path
      );
      setRoute(routeObj);
      if (state) {
        if (path === "/chatgptui/admin" && authToken) {
          navigate("/admin/pdf");
          setState(false);
        }
      }
    } else {
      const routeObj = ADMIN_ROUTES.find((item, i) => `${item.path}` === path);
      setRoute(routeObj);
      if (state) {
        if (path === "/admin/" && authToken) {
          navigate("/admin/pdf");
          setState(false);
        }
      }
    }
    setLoader((prev) => false);
  }, [authToken, window.location.pathname, state]);

  return (
    <AdminContext>
      <div className="admin appLayout h-full w-full relative">
        <Toaster position="top-center" reverseOrder={false} />
        {!loader ? (
          <>
            {route?.isNavBarDisplay && (
              <header className="header sticky top-0 shadow-sm bg-white h-[60px] z-[100] w-full">
                <NavBar />
              </header>
            )}
            <main
              className={`${
                route?.isNavBarDisplay ? "h-[calc(100%_-_62px)]" : "h-full"
              } w-full z-[99] flex relative`}
            >
              <Outlet />
            </main>
          </>
        ) : (
          <Loader />
        )}
      </div>
    </AdminContext>
  );
};

export default AdminSection;
